import React from 'react';
import './Divider.scss';

const Divider: React.FC = () => <div className="Divider" />;

export default Divider;
